(function () {
  'use strict';

  /*
    RAZAB CART DRAWER V15.0
    Self-contained on purpose:
    this theme does NOT require assets/razab-cart.js.
  */
  if (window.__RAZAB_CART_DRAWER_V150__) return;
  window.__RAZAB_CART_DRAWER_V150__ = true;

  var Razab = window.Razab = window.Razab || {};
  console.info('[RAZAB CART] cart-drawer.js V15 loaded');

  function drawer() {
    return document.getElementById('CartDrawer');
  }

  function overlay() {
    return document.querySelector('[data-overlay-for="CartDrawer"]');
  }

  function contents() {
    return document.getElementById('CartDrawerContents');
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cartUrl() {
    return cartRoot() + 'cart';
  }

  function cartAddUrl() {
    return cartRoot() + 'cart/add.js';
  }

  function cartChangeUrl() {
    return cartRoot() + 'cart/change.js';
  }

  function currentPageRefreshUrl() {
    /*
      cart-drawer.liquid is a SNIPPET, not a section, so we cannot call
      ?sections=cart-drawer and fetch just this piece.

      Re-downloading the CURRENT page works but is very expensive: on a
      content-heavy page (the homepage especially) it pulls every section,
      all markup and the catalog JSON just to read one fragment, which makes
      the drawer visibly slow to populate.

      /cart renders the same globally-included drawer snippet from a much
      lighter template, so fetch that instead. The current page is kept as a
      fallback in refreshDrawer() if /cart ever fails.
    */
    var url = new URL('/cart', window.location.origin);
    url.searchParams.set('_rz_cart_refresh', String(Date.now()));
    return url.toString();
  }

  function fallbackPageRefreshUrl() {
    var url = new URL(window.location.href);
    url.hash = '';
    url.searchParams.set('_rz_cart_refresh', String(Date.now()));
    return url.toString();
  }

  function setLoading(state) {
    var panel = drawer();
    if (!panel) return;
    panel.setAttribute('data-loading', state ? 'true' : 'false');
  }

  /*
    iOS Safari ignores overflow:hidden on <html>/<body> for touch scrolling,
    so the page behind the drawer kept scrolling. That made Safari's bottom
    toolbar collapse and expand, the viewport height kept changing, and the
    page showed through under the Checkout button. Pinning <body> in place
    stops the background scroll on every browser; the scroll position is put
    back exactly when the drawer closes.
  */
  var rzScrollLock = null;

  function lockPageScroll() {
    if (rzScrollLock) return;
    var body = document.body;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;

    rzScrollLock = {
      y: y,
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width
    };

    body.style.position = 'fixed';
    body.style.top = (-y) + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
  }

  function unlockPageScroll() {
    if (!rzScrollLock) return;
    var body = document.body;
    var saved = rzScrollLock;
    rzScrollLock = null;

    body.style.position = saved.position;
    body.style.top = saved.top;
    body.style.left = saved.left;
    body.style.right = saved.right;
    body.style.width = saved.width;

    window.scrollTo(0, saved.y);
  }

  function openDrawer() {
    var panel = drawer();
    var shade = overlay();

    if (!panel) {
      console.error('[RAZAB CART] #CartDrawer is not present in the page DOM.');
      window.location.assign(cartUrl());
      return;
    }

    panel.setAttribute('data-open', 'true');
    panel.setAttribute('aria-hidden', 'false');
    panel.classList.add('open', 'active', 'is-open');

    if (shade) {
      shade.setAttribute('data-open', 'true');
      shade.setAttribute('aria-hidden', 'false');
      shade.classList.add('open', 'active', 'is-open');
    }

    document.documentElement.classList.add('rz-cart-drawer-open');
    document.body.classList.add('rz-cart-drawer-open');
    lockPageScroll();

    /*
      Compatibility with the theme's previous panel/drawer manager.
      If these APIs exist, use them too — but the drawer does not depend on them.
    */
    try {
      if (window.Razab && typeof window.Razab.openPanel === 'function') {
        window.Razab.openPanel('CartDrawer');
      }
    } catch (e) {}

    console.info('[RAZAB CART] Drawer opened.');
  }

  function closeDrawer() {
    var panel = drawer();
    var shade = overlay();

    if (panel) {
      panel.setAttribute('data-open', 'false');
      panel.setAttribute('aria-hidden', 'true');
      panel.setAttribute('data-loading', 'false');
      panel.classList.remove('open', 'active', 'is-open');
    }

    if (shade) {
      shade.setAttribute('data-open', 'false');
      shade.setAttribute('aria-hidden', 'true');
      shade.classList.remove('open', 'active', 'is-open');
    }

    document.documentElement.classList.remove('rz-cart-drawer-open');
    document.body.classList.remove('rz-cart-drawer-open');
    unlockPageScroll();

    try {
      if (window.Razab && typeof window.Razab.closePanel === 'function') {
        window.Razab.closePanel('CartDrawer');
      }
    } catch (e) {}
  }

  function updateCartCount(cart) {
    var count = Number(cart && cart.item_count) || 0;

    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      /*
        Preserve the styled badge markup expected by the current header.
      */
      node.innerHTML = count > 0
        ? '<span class="rzs-cart-badge">' + String(count) + '</span>'
        : '';
      node.hidden = false;
    });
  }

  function fetchCartJson() {
    return fetch(cartUrl() + '.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart JSON failed: ' + response.status);
      return response.json();
    });
  }

  function fetchDrawerHtmlFrom(url) {
    return fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Drawer HTML refresh failed: ' + response.status);
        }
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CartDrawerContents');

        if (!fresh) {
          throw new Error('Fresh #CartDrawerContents not found');
        }

        return fresh.innerHTML;
      });
  }

  function fetchFreshDrawerHtml() {
    /* Try the light /cart page first; fall back to the current page. */
    return fetchDrawerHtmlFrom(currentPageRefreshUrl())
      .catch(function () {
        return fetchDrawerHtmlFrom(fallbackPageRefreshUrl());
      });
  }

  function animateMeter(host, fromPercent) {
    var fill = host.querySelector('[data-rzcd-meter-fill]');
    if (!fill) return;

    var target = parseFloat(fill.getAttribute('data-percent'));
    if (isNaN(target)) target = 0;
    target = Math.max(0, Math.min(100, target));

    if (isNaN(fromPercent) || fromPercent === target) {
      fill.style.width = target + '%';
      return;
    }

    var transition = fill.style.transition;
    fill.style.transition = 'none';
    fill.style.width = Math.max(0, Math.min(100, fromPercent)) + '%';
    void fill.offsetWidth; /* commit the start width before animating */
    fill.style.transition = transition;

    window.requestAnimationFrame(function () {
      fill.style.width = target + '%';
    });
  }

  /*
    refreshDrawer(silent)

    silent skips the top loading strip only. The strip is display:none until
    [data-loading="true"] makes it display:block, which inserts roughly 30px
    at the top of the drawer and pushes every row down, then pulls them back
    when the request lands. That shove is what made a quantity step look like
    the row opened and dropped before the number changed.

    Called with no argument it behaves exactly as before, so the header click
    and the remove path are unaffected.
  */
  function refreshDrawer(silent) {
    rzlog('refresh', 'silent=' + !!silent);
    var host = contents();
    if (!host) return Promise.reject(new Error('#CartDrawerContents missing'));

    if (!silent) setLoading(true);

    return Promise.all([
      fetchFreshDrawerHtml(),
      fetchCartJson()
    ])
      .then(function (result) {
        var freshHtml = result[0];
        var cart = result[1];

        /*
          Replacing innerHTML resets the scroll box to the top, which made
          removing an item further down the list feel like the drawer had
          jumped. Capture and restore the scroll offset around the swap.
        */
        var scroller = host.querySelector('.rzcd-body');
        var scrollTop = scroller ? scroller.scrollTop : 0;

        /*
          The free-delivery meter is part of the swapped markup, so without
          this it would snap straight to the new width (or flash empty).
          Remember the old fill and glide from it to the new one.
        */
        var oldFill = host.querySelector('[data-rzcd-meter-fill]');
        var oldPercent = oldFill ? parseFloat(oldFill.getAttribute('data-percent')) : NaN;

        host.innerHTML = freshHtml;

        animateMeter(host, oldPercent);

        var freshScroller = host.querySelector('.rzcd-body');
        if (freshScroller && scrollTop) {
          freshScroller.scrollTop = scrollTop;
        }

        updateCartCount(cart);

        return cart;
      })
      .finally(function () {
        if (!silent) setLoading(false);
      });
  }

  function refreshAndOpen() {
    /*
      Open FIRST. This directly fixes the user's symptom:
      backdrop visible while drawer itself appears missing.
    */
    openDrawer();

    return refreshDrawer().catch(function (error) {
      console.error('[RAZAB CART]', error);

      /*
        Keep the existing server-rendered cart visible even if AJAX refresh
        fails; never leave the user looking at only a blur overlay.
      */
      setLoading(false);
      return null;
    });
  }

  /*
    Add-to-cart open order.

    refreshAndOpen() opens first, which is right for the header cart icon:
    the cart already has its server-rendered contents, so the drawer appears
    instantly and the refresh only tops it up.

    It is wrong for an add. There the drawer slides open still holding the
    PREVIOUS cart - empty on a first add - and the new line only appears a
    moment later, which reads as a broken drawer that fills itself in.

    refreshThenOpen() inverts the order for the add path only, matching the
    collection-page quick-add in theme.js (refresh, then open). While the
    fetch is in flight the drawer stays shut and the button keeps its own
    .is-loading spinner, so the drawer only ever appears already populated.

    refreshAndOpen is left exactly as it was and is still exported.
  */
  function refreshThenOpen() {
    return refreshDrawer()
      .then(function (cart) {
        openDrawer();
        return cart;
      })
      .catch(function (error) {
        console.error('[RAZAB CART]', error);

        /*
          The item did reach the cart, so still show the drawer. It falls back
          to the server-rendered contents rather than leaving the click dead.
        */
        setLoading(false);
        openDrawer();
        return null;
      });
  }

  function add(payload) {
    return fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw body;
          return body;
        });
      })
      .then(function (body) {
        return refreshThenOpen().then(function () {
          return body;
        });
      });
  }

  function changeLine(id, quantity, silent, opToken) {
    if (!silent) setLoading(true);

    return fetch(cartChangeUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: id,
        quantity: Math.max(0, Number(quantity) || 0)
      })
    })
      .then(function (response) {
        if (response.ok) return response.json();

        /*
          Shopify answers a refused change with JSON that explains why, most
          often a 422 when the requested quantity is above what is in stock.
          That reason used to be dropped, so the number simply snapped back to
          the old value with nothing said. Carry it on the error so the caller
          can show it.
        */
        return response
          .json()
          .catch(function () { return {}; })
          .then(function (payload) {
            var reason =
              payload.description ||
              payload.message ||
              ('Cart change failed: ' + response.status);

            var error = new Error(reason);
            error.cartReason = reason;
            error.status = response.status;
            throw error;
          });
      })
      .then(function (cart) {
        /*
          A further step may already be queued for another line. Re-rendering
          now would paint the server's older number over the one the shopper
          is currently looking at, so let the last commit do the render.

          The cart body is passed along either way. /cart/change.js answers a
          quantity above available stock with 200 OK and the number quietly
          clamped, so the only way to know a request was trimmed is to read
          what came back.
        */
        if (silent && hasPendingQtySteps()) return cart;

        rzlog('change ok', 'key=' + short(id), 'asked=' + quantity,
              'token=' + (opToken || '-'), 'now=' + (lineOps[id] || '-'),
              'count=' + (cart && cart.item_count));

        /* Superseded by a newer step or a removal on this line. */
        if (!isCurrentOp(id, opToken)) {
          rzlog('  -> stale, skipping repaint');
          return cart;
        }

        return refreshDrawer(silent).then(function () { return cart; });
      })
      .catch(function (error) {
        setLoading(false);
        console.error('[RAZAB CART]', error);
        throw error;
      });
  }

  /*
    New product-page integration.
  */
  window.RazabCart = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshDrawer,
    refreshAndOpen: refreshAndOpen,
    add: add,
    change: changeLine
  };

  /*
    Legacy compatibility for the rest of the existing theme.
  */
  Razab.refreshCart = refreshDrawer;
  Razab.addToCart = add;
  Razab.changeLine = changeLine;

  /*
    Header cart click.
    Different versions of this theme have used different cart attributes,
    so V14.3 recognizes all of the common trigger shapes.
  */
  function isCartTrigger(target) {
    if (!target || !target.closest) return null;

    return target.closest(
      [
        '[data-cart-link]',
        '[data-cart-drawer-open]',
        '[data-open-cart]',
        '[data-cart-toggle]',
        '[data-open-panel="CartDrawer"]',
        '[data-panel="CartDrawer"]',
        '[aria-controls="CartDrawer"]',
        '#cart-icon-bubble',
        '.header__icon--cart',
        '.rz-cart-trigger',
        'a[href="/cart"]',
        'a[href$="/cart"]'
      ].join(',')
    );
  }

  function handleCartTrigger(event) {
    if (event.__rzCartHandled) return;

    var trigger = isCartTrigger(event.target);
    if (!trigger) return;

    /* Never hijack links/buttons inside the drawer itself. */
    if (trigger.closest('#CartDrawer')) return;

    event.__rzCartHandled = true;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    openDrawer();

    /*
      Refresh after the drawer is visibly open. Even if refresh fails, the
      current server-rendered cart remains visible instead of nothing happening.
    */
    window.setTimeout(function () {
      refreshDrawer().catch(function (error) {
        console.error('[RAZAB CART] Refresh after header click failed:', error);
        setLoading(false);
      });
    }, 30);
  }

  /*
    Capture on BOTH window and document.
    This avoids older header scripts swallowing the click before it reaches us.
  */
  window.addEventListener('click', handleCartTrigger, true);
  document.addEventListener('click', handleCartTrigger, true);

  function bindKnownCartTriggers() {
    document.querySelectorAll(
      [
        '[data-cart-link]',
        '[data-cart-drawer-open]',
        '[data-open-cart]',
        '[data-cart-toggle]',
        '[data-open-panel="CartDrawer"]',
        '[data-panel="CartDrawer"]',
        '[aria-controls="CartDrawer"]',
        '#cart-icon-bubble',
        '.header__icon--cart',
        '.rz-cart-trigger',
        'a[href="/cart"]',
        'a[href$="/cart"]'
      ].join(',')
    ).forEach(function (trigger) {
      if (trigger.dataset.rzCartBound === 'true') return;
      trigger.dataset.rzCartBound = 'true';

      trigger.addEventListener('click', handleCartTrigger, true);
    });
  }

  /*
    Close button + overlay.
  */
  document.addEventListener('click', function (event) {
    var close = event.target.closest(
      '[data-cart-drawer-close], [data-close-panel="CartDrawer"]'
    );

    if (close) {
      event.preventDefault();
      event.stopPropagation();
      closeDrawer();
      return;
    }

    var shade = event.target.closest('[data-overlay-for="CartDrawer"]');
    if (shade && event.target === shade) {
      event.preventDefault();
      event.stopPropagation();
      closeDrawer();
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var panel = drawer();
    if (panel && panel.getAttribute('data-open') === 'true') {
      closeDrawer();
    }
  });

  /* ----------------------------------------------------------------------
     Quantity stepper.

     Previously every + / - click fired the request first and only repainted
     the number when the whole drawer re-rendered, with the loading strip
     shoving the rows down in between. The value now changes on the click and
     the network call follows, debounced, so holding + counts up smoothly
     instead of queueing a re-render per tap.
     ---------------------------------------------------------------------- */
  var qtyTimers = {};
  var QTY_SYNC_DELAY = 320;

  /*
    One counter per line, bumped on every step and every removal.

    Requests finish out of order. Stepping down to nothing while an earlier
    quantity change is still travelling meant the older reply landed after the
    row had gone and repainted it from a cart that still held it, then the
    removal's own reply took it away again: the row vanished, came back, and
    vanished a second time.

    Each operation takes the counter's value when it starts and checks it again
    before repainting. A reply that is no longer the newest for its line stops
    quietly, so only the last thing asked for reaches the screen.
  */
  /*
    TEMPORARY TRACE — remove once the drawer behaves.

    Every step, request and repaint is logged with a timestamp so the order
    things actually happen in can be read off the console instead of guessed
    at. The same lines are kept on window.RZ_CART_LOG so the whole sequence
    can be copied out in one go.
  */
  window.RZ_CART_LOG = [];

  function short(key) {
    return String(key || '').slice(-6);
  }

  function rzlog() {
    var stamp = (performance.now() / 1000).toFixed(3);
    var line = stamp + 's  ' + Array.prototype.slice.call(arguments).join('  ');
    window.RZ_CART_LOG.push(line);
    console.log('%c[RZ CART]', 'color:#c56950;font-weight:bold', line);
  }

  var lineOps = {};

  function nextOp(key) {
    lineOps[key] = (lineOps[key] || 0) + 1;
    rzlog('nextOp', 'key=' + short(key), 'token=' + lineOps[key]);
    return lineOps[key];
  }

  function isCurrentOp(key, token) {
    return !token || lineOps[key] === token;
  }

  function hasPendingQtySteps() {
    for (var key in qtyTimers) {
      if (Object.prototype.hasOwnProperty.call(qtyTimers, key)) return true;
    }
    return false;
  }

  function bumpValue(node, goingUp) {
    if (!node) return;
    node.classList.remove('is-bump-up', 'is-bump-down');
    /* Force a reflow so the animation restarts on a repeat click. */
    void node.offsetWidth;
    node.classList.add(goingUp ? 'is-bump-up' : 'is-bump-down');
  }

  /*
    The two data-qty-change values are rendered by Liquid from the quantity at
    render time, so they go stale the moment we step optimistically. Keep them
    in sync or the second click sends the same number as the first.
  */
  function syncStepAttributes(wrap, quantity) {
    if (!wrap) return;
    var steppers = wrap.querySelectorAll('[data-qty-change]');
    if (steppers[0]) steppers[0].setAttribute('data-qty-change', String(quantity - 1));
    if (steppers[1]) steppers[1].setAttribute('data-qty-change', String(quantity + 1));
  }

  /*
    Shared by the Remove button and by stepping down from 1, so both exit the
    same way instead of one collapsing and the other blinking out.
  */
  function collapseAndRemove(row, key) {
    var token = nextOp(key);
    rzlog('REMOVE', 'key=' + short(key), 'token=' + token);

    if (!row) return changeLine(key, 0, false, token);
    if (row.classList.contains('is-removing')) return Promise.resolve(null);

    var reduced =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    row.style.maxHeight = row.offsetHeight + 'px';
    /* Force a reflow so the transition has a real starting height. */
    void row.offsetHeight;
    row.classList.add('is-removing');

    return new Promise(function (resolve) {
      window.setTimeout(function () {
        resolve(
          changeLine(key, 0, false, token).catch(function () {
            /* Request failed: put the row back rather than leaving a gap. */
            row.classList.remove('is-removing');
            row.style.maxHeight = '';
          })
        );
      }, reduced ? 0 : 230);
    });
  }

  /*
    Put the reason next to the line it belongs to. The note is written into
    the row, so the next re-render replaces it along with everything else and
    there is nothing to clean up.
  */
  function showLineError(wrap, message) {
    if (!wrap || !message) return;

    var row = wrap.closest('.rzcd-item');
    if (!row) return;

    var note = row.querySelector('[data-rzcd-line-error]');
    if (!note) {
      note = document.createElement('p');
      note.className = 'rzcd-line-error';
      note.setAttribute('data-rzcd-line-error', '');
      note.setAttribute('role', 'status');
      row.appendChild(note);
    }

    note.textContent = message;
  }

  function commitQuantity(key, quantity, wrap, token) {
    if (wrap) wrap.setAttribute('data-syncing', 'true');

    return changeLine(key, quantity, true, token)
      .then(function (cart) {
        /*
          Compare what the cart holds against what was asked for. A shortfall
          means Shopify capped the line at the stock it has, so say so and put
          the real number on screen instead of letting it snap back unexplained.
        */
        if (!cart || !cart.items) return cart;

        /* A newer step or a removal has replaced this one; say nothing. */
        if (!isCurrentOp(key, token)) return cart;

        var line = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === key) {
            line = cart.items[i];
            break;
          }
        }

        if (!line || line.quantity === quantity) return cart;

        var freshWrap = document.querySelector(
          '#CartDrawer [data-line-key="' + key + '"]'
        );
        freshWrap = freshWrap ? freshWrap.closest('.rzcd-qty') : wrap;

        if (freshWrap) {
          var valueNode = freshWrap.querySelector('span');
          if (valueNode) valueNode.textContent = String(line.quantity);
          syncStepAttributes(freshWrap, line.quantity);
        }

        showLineError(
          freshWrap,
          'Only ' + line.quantity + ' available, so the quantity was adjusted.'
        );

        return cart;
      })
      .catch(function (error) {
        /*
          The change was refused. Say why, then repaint from the server so the
          number on screen matches the cart rather than the failed request.
        */
        var reason = (error && error.cartReason) || 'Could not update quantity.';
        console.error('[RAZAB CART]', error);

        if (!isCurrentOp(key, token)) return null;

        return refreshDrawer(true)
          .catch(function () { return null; })
          .then(function (cart) {
            var freshWrap = document.querySelector(
              '#CartDrawer [data-line-key="' + key + '"]'
            );
            showLineError(
              freshWrap ? freshWrap.closest('.rzcd-qty') : wrap,
              reason
            );
            return cart;
          });
      })
      .finally(function () {
        if (wrap && wrap.isConnected) wrap.setAttribute('data-syncing', 'false');
      });
  }

  function stepQuantity(button, key, requested) {
    var wrap = button.closest('.rzcd-qty');
    var row = button.closest('.rzcd-item');

    if (!wrap) { changeLine(key, requested); return; }
    if (row && row.classList.contains('is-removing')) return;

    var valueNode = wrap.querySelector('span');
    var current = valueNode ? parseInt(valueNode.textContent, 10) : NaN;
    if (isNaN(current)) current = requested;

    /* Read the direction from the button, take the value from the screen. */
    var next = requested >= current ? current + 1 : current - 1;

    if (next <= 0) {
      window.clearTimeout(qtyTimers[key]);
      delete qtyTimers[key];
      collapseAndRemove(row, key);
      return;
    }

    var token = nextOp(key);
    rzlog('STEP', 'key=' + short(key), 'shown=' + current,
          'attr=' + requested, 'next=' + next, 'token=' + token);

    if (valueNode) {
      valueNode.textContent = String(next);
      bumpValue(valueNode, next > current);
    }

    syncStepAttributes(wrap, next);

    window.clearTimeout(qtyTimers[key]);
    qtyTimers[key] = window.setTimeout(function () {
      delete qtyTimers[key];
      rzlog('commit', 'key=' + short(key), 'qty=' + next, 'token=' + token);
      commitQuantity(key, next, wrap, token);
    }, QTY_SYNC_DELAY);
  }

  /*
    Best-effort support for common cart-drawer item controls.
    Existing theme handlers can continue to operate too.
  */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('#CartDrawer [data-qty-change]');
    if (button) {
      event.preventDefault();
      var key = button.getAttribute('data-line-key');
      var qty = parseInt(button.getAttribute('data-qty-change'), 10);
      if (key && !isNaN(qty)) stepQuantity(button, key, qty);
      return;
    }

    var remove = event.target.closest('#CartDrawer [data-line-remove]');
    if (remove) {
      event.preventDefault();

      var removeKey = remove.getAttribute('data-line-remove');
      if (!removeKey) return;

      var row = remove.closest('.rzcd-item');

      /* Already on its way out: ignore repeat clicks. */
      if (row && row.classList.contains('is-removing')) return;

      /*
        Collapse the row first so the removal reads as deliberate, then send
        the request. The drawer re-renders when it lands, which replaces this
        element anyway, so there is nothing to clean up afterwards.
      */
      window.clearTimeout(qtyTimers[removeKey]);
      delete qtyTimers[removeKey];
      collapseAndRemove(row, removeKey);
    }
  });

  /*
    In case an old script has already left the backdrop open but the drawer
    closed, normalize that broken state on page load.
  */
  function initialiseCartDrawer() {
    var panel = drawer();
    var shade = overlay();

    if (panel) {
      panel.setAttribute('data-open', 'false');
      panel.setAttribute('aria-hidden', 'true');
      panel.classList.remove('open', 'active', 'is-open');
    } else {
      console.error(
        '[RAZAB CART] cart-drawer snippet script loaded, but #CartDrawer was not found. ' +
        'Make sure {% render "cart-drawer" %} exists in layout/theme.liquid or header.liquid.'
      );
    }

    if (shade) {
      shade.setAttribute('data-open', 'false');
      shade.setAttribute('aria-hidden', 'true');
      shade.classList.remove('open', 'active', 'is-open');
    }

    document.documentElement.classList.remove('rz-cart-drawer-open');
    document.body.classList.remove('rz-cart-drawer-open');

    bindKnownCartTriggers();

    console.info(
      '[RAZAB CART] V14.3 ready. Drawer:',
      !!panel,
      'Triggers:',
      document.querySelectorAll(
        '[data-cart-link],[data-cart-drawer-open],[data-open-cart],[data-cart-toggle],' +
        '[data-open-panel="CartDrawer"],[data-panel="CartDrawer"],[aria-controls="CartDrawer"],' +
        '#cart-icon-bubble,.header__icon--cart,.rz-cart-trigger,a[href="/cart"],a[href$="/cart"]'
      ).length
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseCartDrawer, { once:true });
  } else {
    initialiseCartDrawer();
  }

  /*
    Shopify Theme Editor / header section reloads can replace the cart trigger.
    Rebind after every section reload.
  */
  document.addEventListener('shopify:section:load', function () {
    bindKnownCartTriggers();
  });
})();
